import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection: React.FC = () => {
  return (
    <section className="bg-gradient-to-br from-primary to-secondary py-16 lg:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mx-auto mb-6">
          <Icon name="Rocket" size={32} color="white" />
        </div>
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
          Ready to Transform Your Industry?
        </h2>
        <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
          Join hundreds of businesses that have already automated their way to success. Get a free
          automation audit tailored to your industry.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <Button
              variant="default"
              size="lg"
              iconName="Calendar"
              iconPosition="left"
              className="bg-white text-primary hover:bg-white/90"
            >
              Book Free Audit
            </Button>
          </Link>
          <Link to="/case-studies">
            <Button
              variant="outline"
              size="lg"
              iconName="FileText"
              iconPosition="left"
              className="border-white text-white hover:bg-white/10"
            >
              View Case Studies
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;